// extracted by mini-css-extract-plugin
export default {"wrap":"MarqueeText_wrap_nB7xP","content":"MarqueeText_content_BXbWs","text":"MarqueeText_text_sbKRR","animation":"MarqueeText_animation_ZM7ZR","paused":"MarqueeText_paused_xXhpF"};